import React, { useState } from "react";

const PRESETS = ["Today", "Yesterday", "This Week", "This Month", "Custom"];

const getRangeForPreset = (preset, customStart, customEnd) => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endOfToday = new Date(startOfToday);
  endOfToday.setHours(23, 59, 59, 999);

  switch (preset) {
    case "Today":
      return { startDate: startOfToday.toISOString(), endDate: endOfToday.toISOString() };
    case "Yesterday": {
      const start = new Date(startOfToday);
      start.setDate(start.getDate() - 1);
      const end = new Date(start);
      end.setHours(23, 59, 59, 999);
      return { startDate: start.toISOString(), endDate: end.toISOString() };
    }
    case "This Week": {
      const start = new Date(startOfToday);
      start.setDate(start.getDate() - start.getDay());
      return { startDate: start.toISOString(), endDate: endOfToday.toISOString() };
    }
    case "This Month": {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return { startDate: start.toISOString(), endDate: endOfToday.toISOString() };
    }
    case "Custom": {
      if (!customStart || !customEnd) return {};
      const start = new Date(customStart);
      start.setHours(0, 0, 0, 0);
      const end = new Date(customEnd);
      end.setHours(23, 59, 59, 999);
      return { startDate: start.toISOString(), endDate: end.toISOString() };
    }
    default:
      return {};
  }
};

const DateRangeFilter = ({ onChange }) => {
  const [preset, setPreset] = useState("This Month");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");

  const applyPreset = (p) => {
    setPreset(p);
    if (p !== "Custom") {
      onChange(getRangeForPreset(p));
    }
  };

  const applyCustom = () => {
    if (customStart && customEnd) {
      onChange(getRangeForPreset("Custom", customStart, customEnd));
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.chipRow}>
        {PRESETS.map((p) => (
          <button
            key={p}
            onClick={() => applyPreset(p)}
            style={{ ...styles.chip, ...(preset === p ? styles.chipActive : {}) }}
          >
            {p}
          </button>
        ))}
      </div>

      {preset === "Custom" && (
        <div style={styles.customRow}>
          <input
            type="date"
            value={customStart}
            onChange={(e) => setCustomStart(e.target.value)}
            style={styles.dateInput}
          />
          <span style={{ color: "#94a3b8" }}>to</span>
          <input
            type="date"
            value={customEnd}
            onChange={(e) => setCustomEnd(e.target.value)}
            style={styles.dateInput}
          />
          <button onClick={applyCustom} style={styles.applyBtn}>
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  wrap: { marginBottom: "20px" },
  chipRow: { display: "flex", gap: "8px", flexWrap: "wrap" },
  chip: {
    padding: "8px 16px",
    borderRadius: "20px",
    border: "1px solid #e2e8f0",
    background: "#fff",
    fontSize: "13px",
    fontWeight: "600",
    color: "#64748b",
    cursor: "pointer",
  },
  chipActive: { background: "#2563eb", color: "#fff", borderColor: "#2563eb" },
  customRow: { display: "flex", gap: "10px", alignItems: "center", marginTop: "12px" },
  dateInput: { padding: "8px 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" },
  applyBtn: {
    padding: "8px 16px",
    borderRadius: "8px",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default DateRangeFilter;